import Vue from 'vue'
import Router from 'vue-router'
import kbxmList from '../views/kbxmList.vue'
import adminLogin from '../views/adminLogin.vue'
import xmlc from '../views/xmlc.vue'
import tbwjFile from '../views/tbwjFile.vue'

import qd from '../views/qd.vue'
import jmCom from '../components/jmCom'

import xbjl from '../views/xbjl.vue'
import yxxsc from '../views/yxxsc.vue'
import jm from '../views/jm.vue'
import cb from '../views/cb.vue'
import kbbb from '../views/kbbb.vue'
import gqcgCb from '../views/gqcgCb.vue'
import gqcgKbbb from '../views/gqcgKbbb.vue'
import fhxsc from '../views/fhxsc.vue'
import zgfhxsc from '../views/zgfhxsc.vue'
import tjzbhxr from '../views/tjzbhxr.vue'
import zbhxr from '../views/zbhxr.vue'
import kbjs from '../views/kbjs.vue'
import kbdjs from '../views/kbdjs.vue'
import dybb from '../views/dybb.vue'
import tbkbdjs from '../views/tbkbdjs.vue'
import tbView from '../views/tbView.vue'
import kpytkb from '../views/kpytkb.vue'

import adminIndex from '../views/adminIndex.vue'
import zygl from '../views/admin/zygl.vue'
import qxgl from '../views/admin/qxgl.vue'
import jsgl from '../views/admin/jsgl.vue'
import dlgl from '../views/admin/dlgl.vue'
import gsjggl from '../views/admin/gsjggl.vue'
import lcpz from '../views/admin/lcpz.vue'
import lcgl from '../views/admin/lcgl.vue'
import mbgl from '../views/admin/mbgl.vue'
import kbsz from '../views/admin/kbsz.vue'

import logout from '../views/logout.vue'
import ssoLogin from '../views/ssoLogin.vue'
import Error404 from '../views/Error404.vue'
import qZ from '../views/qZ.vue'
import drawLots from '../components/drawLots/index.vue'
Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            redirect: '/logout'
        },
        {
            path: '/qz',
            name: 'qz',
            component: qZ,
            meta: { auth: true },
        },
        {
            path: '/sxt',
            name: 'sxt',
            component: () =>import ('../components/video/sxt.vue'),
            meta: { auth: true },
        },
        {
            path: '/logout',
            name: 'logout',
            component: logout
        },
        {
            path: '/sso-login',
            name: 'ssoLogin',
            component: ssoLogin
        },
        // {
        //     path: '/admin',
        //     name: 'admin',
        //     component: adminLogin
        // },
        {
            path: '/testjm',
            name: 'jmCom',
            component: jmCom
        },
        {
            path: '/adminIndex',
            name: 'adminIndex',
            component: adminIndex,
            meta: { auth: true },
            children: [
                {
                    path: '/zygl',
                    name: 'zygl',
                    component: zygl
                },
                {
                    path: '/qxgl',
                    name: 'qxgl',
                    component: qxgl
                },
                {
                    path: '/jsgl',
                    name: 'jsgl',
                    component: jsgl
                },
                {
                    path: '/dlgl',
                    name: 'dlgl',
                    component: dlgl
                },
                {
                    path: '/gsjggl',
                    name: 'gsjggl',
                    component: gsjggl
                },
                {
                    path: '/lcgl',
                    name: 'lcgl',
                    component: lcgl
                },
                {
                    path: '/lcpz',
                    name: 'lcpz',
                    component: lcpz
                },
                {
                    path: '/mbgl',
                    name: 'mbgl',
                    component: mbgl
                },
                {
                    path: '/kbsz',
                    name: 'kbsz',
                    component: kbsz
                },
            ]

        },
        {
            path: '/kbxmList',
            name: 'kbxmList',
            component: kbxmList,
            meta: { auth: true },
        },
        {
            path: '/tbwjFile',
            name: 'tbwjFile',
            component: tbwjFile,
            meta: { auth: true },
        },
        {
            path: '/xmlc',
            name: 'xmlc',
            component: xmlc,
            meta: { auth: true },
            children: [
                {
                    path: '/bj',
                    name: 'bj',
                    component: () =>import ('../views/ncbj.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/tbView',
                    name: 'tbView',
                    component: tbView,
                    meta: { auth: true }
                },
                {
                    path: '/qd',
                    name: 'qd',
                    component: qd,
                    meta: { auth: true }
                },
                {
                    path: '/xbjl',
                    name: 'xbjl',
                    component: xbjl,
                    meta: { auth: true },
                },
                {
                    path: '/yxxsc',
                    name: 'yxxsc',
                    component: yxxsc,
                    meta: { auth: true },
                },
                {
                    path: '/jm',
                    name: 'jm',
                    component: jm,
                    meta: { auth: true },
                },
                {
                    path: '/cb',
                    name: 'cb',
                    component: cb,
                    meta: { auth: true },
                },
                {
                    path: '/kbbb',
                    name: 'kbbb',
                    component: kbbb,
                    meta: { auth: true },
                },
                {
                    path: '/gqcgCb',
                    name: 'gqcgCb',
                    component: gqcgCb,
                    meta: { auth: true },
                },
                {
                    path: '/gqcgKbbb',
                    name: 'gqcgKbbb',
                    component: gqcgKbbb,
                    meta: { auth: true },
                },
                {
                    path: '/fhxsc',
                    name: 'fhxsc',
                    component: fhxsc,
                    meta: { auth: true },
                },
                {
                    path: '/zbhxr',
                    name: 'zbhxr',
                    component: zbhxr,
                    meta: { auth: true },
                },
                {
                    path: '/kbjs',
                    name: 'kbjs',
                    component: kbjs,
                    meta: { auth: true },
                },
                {
                    path: '/kbdjs',
                    name: 'kbdjs',
                    component: kbdjs,
                    meta: { auth: true },
                },
                {
                    path: '/tbkbdjs',
                    name: 'tbkbdjs',
                    component: tbkbdjs,
                    meta: { auth: true },
                },
            ]
        },
        {
            path: '/lookTbwj',
            name: 'LookTbwj',
            component: () => import('@/views/components/lookTbwj'),
        },
        // 竞争性比选
        {
            path: '/bxxmlc',
            name: 'bxxmlc',
            component: () =>import ('../views/CompetitiveSelection/bxxmlc.vue'),
            meta: { auth: true },
            children: [
                {
                    path: '/bxKbdjs',
                    name: 'bxKbdjs',
                    component: () =>import ('../views/CompetitiveSelection/bxKbdjs.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/bxYxxsc',
                    name: 'bxYxxsc',
                    component: () =>import ('../views/CompetitiveSelection/bxYxxsc.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/bxcb',
                    name: 'bxcb',
                    component: () =>import ('../views/CompetitiveSelection/bxcb.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/bxTjzbhxr',
                    name: 'bxTjzbhxr',
                    component: () =>import ('../views/CompetitiveSelection/bxTjzbhxr.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/bxKbjlb',
                    name: 'bxKbjlb',
                    component: () =>import ('../views/CompetitiveSelection/bxKbjlb.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/bxKbjs',
                    name: 'bxKbjs',
                    component: () =>import ('../views/CompetitiveSelection/bxKbjs.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/zgfhxsc',
                    name: 'zgfhxsc',
                    component: zgfhxsc,
                    meta: { auth: true },
                },
                {
                    path: '/fhxscsjf',
                    name: 'fhxscsjf',
                    component: () => import('../views/fhxscsjf.vue'),
                    meta: { auth: true },
                },
                {
                    path: '/tjzbhxr',
                    name: 'tjzbhxr',
                    component: tjzbhxr,
                    meta: { auth: true },
                },
                {
                    path: '/dybb',
                    name: 'dybb',
                    component: dybb,
                    meta: { auth: true },
                },
                {
                    path: '/kpytkb',
                    name: 'kpytkb',
                    component: kpytkb,
                    meta: { auth: true },
                },
            ]
        },
        {
            path: '/drawLots',
            name: 'drawLots',
            component: drawLots
        },
        {
            path: '*',
            component: Error404
        }
    ]
})
/**
 * 重写路由的push方法
 * 解决，相同路由跳转时，报错
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
